export function replaceWithSecrets(str, secrets) {
  if (!str) {
    return ''
  }
  return str.includes('{{{')
    ? this.call('replaceLiteralsWithObjectFields', str, { bracketsLength: 3 }, secrets)
    : str
}

export function replaceSecretsWithKeys(code, secrets) {
  if (!code || !secrets) {
    return code || ''
  }
  const secretKeys = Object.keys(secrets)
  if (secretKeys.length) {
    secretKeys.forEach((secret) => {
      const val = secrets[secret]

      code = code.replaceAll(val, `{{{ ${secret} }}}`)
    })
  }
  return code
}

export function getCode() {
  const { state } = this
  const route = this.call('getLastLocationPath', 0)
  const propsCode = this.parent.code
  if (propsCode === 'components') {
    return this.call('deepClone', state.value)
  } else if (propsCode === 'designSystem') {
    const rootCode = this.getDesignSystem() || {}
    const subRoute = route !== '/design-system' && route.slice(1).toUpperCase()
    return subRoute ? rootCode[subRoute] : rootCode
  } else if (propsCode === 'state') {
    const rootCode = this.getData('state') || {}
    const subRoute =
      this.call('getLastLocationPath', 1) && this.call('getLastLocationPath', 1).slice(1)
    return subRoute ? rootCode[subRoute] : rootCode
  } else if (propsCode === 'data') {
    return this.getData()
  } else if (propsCode === 'schema') {
    return this.getSchema()
  }
}

export function stringifyCode(
  code,
  options = { preventExportDefult: false, syntax: '{}', indent: 0 }
) {
  const { state } = this
  const codeToConvert = code || this.call('getCode', this, state)
  const codeStr = this.call('isString', codeToConvert)
    ? codeToConvert
    : this.call('isFunction', codeToConvert)
      ? codeToConvert.toString()
      : this.call('objectToString', codeToConvert, options.indent)
  const exportDefault = options.preventExportDefult ? '' : 'export default '
  if (!codeToConvert) {
    return exportDefault + (options.syntax || '{}')
  }
  return exportDefault + this.replaceSecretsWithKeys(codeStr, this.getSecrets())
}

// export function evalStringCode(codeStr, opts = {}) {
//   if (!codeStr) {
//     return null
//   }
//   const codeVal = codeStr.startsWith('export default ')
//     ? codeStr.slice('export default '.length)
//     : codeStr
//   const code = this.replaceWithSecrets(codeVal, this.getSecrets?.())
//   return this.call('evalStringToObject', code, { verbose: true, ...opts })
// }

// NOTE: async since the bundle-split (T2) — acorn (~200 KB, the only consumer
// in the eager shell) is dynamic-imported at use time. All callers await:
// keyboard-shortcuts onPaste, governance Projects onCodeEditCallback,
// extensions assistant parseResponse.
export async function parseStringCode(codeStr, opts = {}) {
  if (!codeStr) return null

  if (codeStr.startsWith('export default ')) codeStr = codeStr.slice('export default '.length)

  try {
    const acorn = await import('acorn')
    // Parse with range info so we can slice original code. `preserveParens`
    // lets us prove the WHOLE buffer is the one wrapped expression: a buffer
    // like `a) , (b` escapes the wrapping parens and used to save a fragment.
    const wrapped = `(${codeStr})`
    const ast = acorn.parse(wrapped, {
      ecmaVersion: 'latest',
      sourceType: 'module',
      ranges: true,
      preserveParens: true
    })
    const top =
      ast.body.length === 1 && ast.body[0].type === 'ExpressionStatement' ? ast.body[0].expression : null
    if (!top || top.type !== 'ParenthesizedExpression' || top.start !== 0 || top.end !== wrapped.length) {
      throw new Error('Not a single expression')
    }

    const src = (node) => wrapped.slice(node.start, node.end)
    const unparen = (node) => (node && node.type === 'ParenthesizedExpression' ? unparen(node.expression) : node)
    // A method / accessor value as a FUNCTION SOURCE (review M1): acorn starts
    // a method's FunctionExpression at its params, so the value slice alone is
    // "(ev, el) {…}" — not a function, never revived. Re-emit the keyword.
    const fnSource = (fn) =>
      (fn.async ? 'async ' : '') + 'function' + (fn.generator ? '* ' : ' ') + wrapped.slice(fn.start, fn.end)
    // An own key, whatever its name — `__proto__` never sets the prototype.
    const define = (obj, key, value) =>
      Object.defineProperty(obj, key, { value, enumerable: true, writable: true, configurable: true })

    // ---- AST → Object or Raw Source (nothing is evaluated) ----
    function astToObject(node) {
      if (!node) return null

      switch (node.type) {
        case 'ParenthesizedExpression':
          return astToObject(node.expression)

        case 'Literal':
          return node.value

        case 'Identifier':
          if (node.name === 'undefined') return undefined
          if (node.name === 'NaN') return NaN
          if (node.name === 'Infinity') return Infinity
          return src(node)

        case 'UnaryExpression': {
          const arg = unparen(node.argument)
          if ((node.operator === '-' || node.operator === '+') && arg.type === 'Literal' && typeof arg.value === 'number') {
            return node.operator === '-' ? -arg.value : +arg.value
          }
          if (node.operator === '-' && arg.type === 'Identifier' && arg.name === 'Infinity') return -Infinity
          return src(node)
        }

        case 'TemplateLiteral':
          // no expressions: the string itself; with expressions: the source,
          // backticks included (a template is code, not a value)
          return node.expressions.length ? src(node) : node.quasis.map((q) => q.value.cooked).join('')

        case 'ArrayExpression':
          return node.elements.map((el) => (el ? astToObject(el) : null))

        case 'ObjectExpression': {
          const obj = {}
          for (const prop of node.properties) {
            if (prop.type === 'Property') {
              const key =
                !prop.computed && prop.key.type === 'Identifier'
                  ? prop.key.name
                  : prop.key.type === 'Literal'
                    ? String(prop.key.value)
                    : src(prop.key)
              const isFn = prop.method || prop.kind === 'get' || prop.kind === 'set'
              define(obj, key, isFn ? fnSource(prop.value) : astToObject(prop.value))
            } else if (prop.type === 'SpreadElement') {
              define(obj, `...${src(prop.argument)}`, astToObject(prop.argument))
            }
          }
          return obj
        }

        default:
          return src(node)
      }
    }

    const objectified = astToObject(top.expression)
    if (objectified) return objectified

    throw new Error('Failed to parse object')
  } catch (e) {
    if (opts.onError) opts.onError(e)
    console.error('Can not parse the string: ' + e.message)
    console.error(e)
    return null
  }
}
